<template>
  <div id="text-content" :class="{'larger-header' : largerHeader }">
    <Header />
    <router-view></router-view>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import Header from './components/templates/TextContentHeader';
// import translations from './store/modules/translations';
import utils from './lib/utils';

const { mapMutations, mapActions } = createNamespacedHelpers('translations');

export default {
  name: 'TextContentApp',
  components: {
    Header
  },
  created() {
    if (!utils.hasProperty(window.translations, 'dict')) {
      this.fetchAll(window.translations)
        .then((dict) => {
          console.log('dict fetched');
          console.log(dict);
          this.$store.state.translations.dict = dict;
        });
    } else {
      this.setDict(window.translations.dict);
    }
  },
  computed: {
    largerHeader() {
      return (('careerpeakr' in window)
        && ('textHeader' in window.careerpeakr)
        && ('large' in window.careerpeakr.textHeader)
        && (window.careerpeakr.textHeader.large));
    }
  },
  methods: {
    ...mapMutations(['setDict']),
    ...mapActions(['fetchAll'])
  }
};
</script>

<style lang="scss">
@import 'scss/app';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.larger-header .cp-home-header {
  height: 400px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

p {
  font-family: $font-body;
  font-weight: $font-regular;
  color: $color-darkgrey;
  font-size: 17px;
  line-height: 28px;
}

.public.privacypage {
  font-family: $font-body;
  font-weight: $font-regular;
  color: $color-darkgrey;

  #toparea h1 {
    font-size: 48px;
    line-height: 61px;
    color: #ffffff;
  }
}

#content > .wrapper > ol
{
  font-weight: $font-regular !important;

  li h2, .contact {
    font-size: 24px;
    font-weight: $font-regular !important;
    color: $color-blue-light;
  }
}

#content > .wrapper h3 {
  font-weight: 900 !important;
}

ol.topic {
  border-bottom: none !important;
  font-weight: $font-regular !important;

  li {
    font-weight: 900;
    font-size: 17px !important;
  }
}

.topic ul, ul {
  > li {
    padding-left: 40px;
    line-height: 28px;
    padding-bottom: 14px;
    font-family: $font-body;
    font-weight: $font-regular;
    color: $color-darkgrey;
    font-size: 17px;

    &:before {
      content: '\e813';
      color: $color-blue;
      font-family: fontello;  // stylelint-disable-line
      margin-left: -40px;
      margin-right: calc(40px - 1em);
      padding-right: 0;
    }
  }
}

.contact {
  background-color: $color-ultralightgrey;
  padding: 5px 0px;

  & > .wrapper {
    display: block !important;
    max-width: 793px;
    margin: 70px auto;
    font-weight: 300;
    line-height: 28px;
    font-size: 17px;
  }

  h2 {
    list-style: none;
    font-size: 24px;
    font-weight: 400 !important;
    color: #00c6f8;
    border-bottom: 1px solid $color-silvergrey;
  }

  a:link {
    color: $color-darkgrey;
    font-weight: bold;
  }
}

@include bp-max-medium() {

  #toparea {
    margin-top: -310px !important;
  }

  .public.privacypage #toparea h1 {
    font-size: 32px !important;
    line-height: 35px;
    font-weight: 400;
  }

  #content > .wrapper  {
    margin: 40px 30px 70px 36px;

    &.agb-wrapper {
      margin: -20px 30px 70px 36px;
    }
  }
  .contact > .wrapper {
    margin: 27px 30px 35px 35px;
  }
}
</style>
